import { useForm } from 'react-hook-form';
import { resolver } from './resolver';

const defaultValues = {
  clabe: '',
};

export const useCreateClabeForm = ({
  borrowerBanks,
  createClabeMutation,
}) => {
  const {
    control,
    handleSubmit,
  } = useForm({
    resolver,
    defaultValues,
    context: {
      borrowerBanks,
    },
  });

  const submitHandler = (values) => createClabeMutation({
    variables: {
      input: {
        clabe: values.clabe,
      },
    },
  });

  const onSubmit = handleSubmit(submitHandler);

  return {
    control,
    onSubmit,
  };
};
